
// src/api/my_reflection_api.js
import { API_BASE } from "./common_api";


// ================= LOAD LIST =================
export async function fetchMyReflectionList(email, period) {
  const res = await fetch(
    `${API_BASE}/reflection/view?email=${encodeURIComponent(
      email
    )}&period=${period}`
  );

  const data = await res.json();
  return data;
}

// ================= UPDATE REFLECTION =================
export async function updateReflection(reflectionId, q1, q2, q3) {
  const fd = new FormData();
  fd.append("reflection_id", reflectionId);
  fd.append("q1", q1);
  fd.append("q2", q2);
  fd.append("q3", q3);

  const res = await fetch(`${API_BASE}/reflection/update`, {
    method: "PATCH",
    body: fd,
  });

  // ======= IMPORTANT FIX =========
  if (!res.ok) {
    let msg = "Update not allowed";

    try {
      const err = await res.json();
      msg = err?.message || err?.detail || msg;
    } catch {}

    return {
      success: false,
      message: msg,
      status: res.status,
    };
  }

  const data = await res.json();
  return {
    ...data,
    success: true,
  };
}

// src/api/my_reflection_api.js
// ... existing code ...

// ================= DELETE =================
export async function deleteReflection(reflectionId) {
  try {
    const res = await fetch(
      `${API_BASE}/reflection/delete?reflection_id=${reflectionId}`,
      { method: "DELETE" }
    );

    // ✅ IMPORTANT: Check if response is not OK (400, 403, etc.)
    if (!res.ok) {
      let errorMessage = "Cannot delete reflection (24-hour limit exceeded)";
      
      try {
        const errorData = await res.json();
        errorMessage = errorData?.message || errorData?.detail || errorMessage;
      } catch (jsonError) {
        // If response is not JSON, use status text
        errorMessage = res.statusText || errorMessage;
      }
      
      return {
        success: false,
        message: errorMessage,
        status: res.status
      };
    }

    // ✅ If response is OK (200)
    const data = await res.json();
    return {
      ...data,
      success: true
    };
    
  } catch (networkError) {
    // Network error (no internet, etc.)
    return {
      success: false,
      message: "Network error: " + networkError.message,
      status: 0
    };
  }
}